(() => {
  'use strict';

  document.querySelectorAll('[data-pm-vendor-dropdown]').forEach((root) => {
    const select = root.querySelector('select');
    const trigger = root.querySelector('[data-pm-vendor-dropdown-trigger]');
    const panelId = trigger && trigger.getAttribute('aria-controls');
    const panel = panelId && document.getElementById(panelId);
    // panel sigue siendo la caja visual exterior: elemento que se
    // muestra/oculta (panel.hidden), aria-controls target, y el área que
    // root.contains(...) usa para decidir si un clic/foco está dentro del
    // componente. panelScroller (nuevo wrapper .pm-vendor-dropdown-scroller,
    // snippets/header-search.liquid) es ahora, en exclusiva, el elemento
    // scrollable real: fuente de scrollTop/scrollHeight/clientHeight/
    // clientTop y de getBoundingClientRect() para la matemática de
    // posicionamiento. La inicialización enhanced solo continúa si también
    // existe -- si el markup aún no incluye el wrapper, el componente no se
    // activa y el <select> nativo original sigue siendo 100% funcional.
    const panelScroller = panel && panel.querySelector('.pm-vendor-dropdown-scroller');
    // Falla "el teclado no se abre en mobile" (24SEP2026): todo lo de
    // arriba dependía exclusivamente del typeahead NATIVO de un <select>
    // enfocado -- funciona con teclado físico, pero un <select> nunca
    // abre el teclado táctil en mobile (y este componente deliberadamente
    // nunca llama a select.click()/showPicker() para no mostrar el picker
    // nativo encima del panel visual). searchInput es un <input type=
    // "text"> real: en mobile SÍ abre teclado al enfocarse, siempre que
    // el foco ocurra de forma síncrona dentro del gesto del usuario (el
    // mismo click del trigger) -- exactamente donde se llama más abajo.
    const searchInput = panel && panel.querySelector('[data-pm-vendor-dropdown-search]');
    const emptyMessage = panel && panel.querySelector('[data-pm-vendor-dropdown-empty]');

    if (!select || !trigger || !panel || !panelScroller || !searchInput || !emptyMessage) return;
    if (!panel.hasAttribute('data-pm-vendor-dropdown-panel')) return;
    if (panel.id !== panelId) return;

    root.classList.add('pm-vendor-dropdown-ready');

    // tabIndex=-1 retira el select de la secuencia de Tab (el trigger es la
    // única superficie visible) pero NO le impide recibir foco programático
    // vía select.focus() -- comportamiento estándar del DOM, confirmado
    // antes de conservarlo. aria-hidden se retira por completo (no se
    // aplica en ningún punto): un elemento que va a recibir foco real
    // (document.activeElement === select durante todo el typeahead) nunca
    // puede quedar aria-hidden="true" -- sería incorrecto desde
    // accesibilidad. El estado anterior sí lo aplicaba, pero entonces el
    // select nunca recibía foco real.
    select.tabIndex = -1;

    // Auditado en snippets/header-search.liquid: este <select> es el mismo
    // que usa Athens (clase select-custom + header-global-search-categories),
    // con id_prefix-filter. Sus <option> son exactamente el mismo bucle
    // Liquid (menu_vendors.links) que genera los <a> del panel PM, en el
    // mismo orden, con el mismo valor de URL en option.value y en a[href].
    // El onchange original es un atributo inline:
    //   onchange="if (this.value) window.location.assign(this.value)"
    // Se captura su valor antes de retirarlo -- únicamente para dejar
    // constancia explícita de qué se neutraliza, nunca para restaurarlo: si
    // este script no llega a ejecutarse (falla la carga, o select/trigger/
    // panel no son válidos), el atributo nunca se toca y Athens navega
    // exactamente igual que sin progressive enhancement. removeAttribute ya
    // desactiva el manejador compilado por el propio parser HTML, pero se
    // fija también select.onchange = null como confirmación explícita,
    // sin depender únicamente de ese comportamiento del navegador.
    var originalOnchangeAttr = select.getAttribute('onchange');
    if (originalOnchangeAttr) {
      select.removeAttribute('onchange');
      select.onchange = null;
    }

    // Fuente única de verdad para "abierto": panel.hidden -- el atributo
    // nativo real que además controla display:none vía CSS
    // (.pm-vendor-dropdown-panel[hidden]). aria-expanded es solo un
    // reflejo accesible, nunca una segunda fuente de verdad.
    function isOpen() {
      return !panel.hidden;
    }

    // Desplaza EXCLUSIVAMENTE panelScroller.scrollTop, calculado mediante
    // getBoundingClientRect() -- nunca offsetTop/offsetParent, nunca
    // scrollIntoView(), nunca scroll de window/document/body. panel ya
    // no es el elemento con scroll (ahora overflow:hidden, solo
    // clipping/geometría visual) -- panelScroller es el nuevo wrapper
    // .pm-vendor-dropdown-scroller, el único con overflow-y:auto real.
    // panelScroller.clientTop corrige cualquier borde propio del
    // scroller entre el borde exterior que devuelve
    // getBoundingClientRect() y el origen real de scrollTop=0 (hoy el
    // scroller no tiene borde, así que evalúa a 0; se conserva en la
    // fórmula por generalidad, no por necesidad actual). Posiciona la
    // coincidencia junto al borde SUPERIOR del scroller a propósito (no
    // "nearest"). El resultado se acota a [0, scrollHeight - clientHeight].
    function scrollMatchIntoScroller(match) {
      var scrollerRect = panelScroller.getBoundingClientRect();
      var matchRect = match.getBoundingClientRect();
      var targetScroll =
        panelScroller.scrollTop + (matchRect.top - scrollerRect.top - panelScroller.clientTop);
      var maxScroll = panelScroller.scrollHeight - panelScroller.clientHeight;
      targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
      panelScroller.scrollTop = targetScroll;
    }

    // Relación option -> <a> por URL real (preferencia explícita de la
    // tarea), no por índice asumido -- aunque la auditoría confirmó que
    // ambos bucles Liquid comparten fuente y orden, comparar el valor real
    // de option.value contra a[href] es la relación determinista pedida.
    // new URL(valor, origin) normaliza relativa vs. absoluta antes de
    // comparar, para no depender de qué forma use cada una.
    function findLinkForOption(option) {
      if (!option || !option.value) return null;
      var targetUrl = new URL(option.value, window.location.origin).href;
      var links = panel.querySelectorAll('.pm-vendor-dropdown-list a');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href');
        if (!href) continue;
        if (new URL(href, window.location.origin).href === targetUrl) return links[i];
      }
      return null;
    }

    // Una sola fila puede estar resaltada a la vez: retira .is-highlighted
    // de cualquier coincidencia anterior. Reutiliza exactamente la clase
    // que assets/pm-platform-header.css ya contempla en
    // "#header .pm-vendor-dropdown-list a.is-highlighted" -- CSS ya
    // preparado, ningún estilo nuevo. Buscada dentro de panel (no de todo
    // el documento) por la misma razón de scoping que ya usa
    // findLinkForOption.
    function clearHighlightedVendor() {
      var previous = panel.querySelector('.pm-vendor-dropdown-list a.is-highlighted');
      if (previous) previous.classList.remove('is-highlighted');
    }

    // Única función responsable de sincronizar la opción nativa
    // seleccionada con el panel visual. No compara texto, no conoce qué
    // escribió el usuario ni mantiene buffer propio -- el navegador ya
    // resolvió esa coincidencia mediante su propio typeahead nativo sobre
    // el <select>; esta función solo traduce selectedIndex/value a una
    // posición de scroll (y, ahora, también a la fila resaltada -- misma
    // coincidencia ya calculada, sin un segundo algoritmo de búsqueda).
    // Idempotente: llamarla repetidamente con el mismo selectedIndex
    // recalcula el mismo scrollTop y el mismo highlight sin efectos
    // acumulativos. Nunca mueve el foco a un <a> -- el foco debe
    // permanecer en el <select> para que el buffer nativo del navegador
    // siga recibiendo teclas (S -> SE -> SENNHEISER en una sola
    // secuencia).
    function syncNativeSelection() {
      if (!isOpen()) return;
      var selectedOption = select.options[select.selectedIndex];
      if (!selectedOption || selectedOption.value === '') {
        // Placeholder ("Todas las Marcas") seleccionado -- ya no hay
        // coincidencia válida, se limpia cualquier resaltado previo.
        clearHighlightedVendor();
        return;
      }
      var match = findLinkForOption(selectedOption);
      if (!match) {
        // Defensivo: value real sin <a> correspondiente -- tampoco hay
        // coincidencia válida que resaltar.
        clearHighlightedVendor();
        return;
      }
      clearHighlightedVendor();
      match.classList.add('is-highlighted');
      scrollMatchIntoScroller(match);
    }

    // Reinicia el select al placeholder ("Todas las Marcas") mediante
    // asignación directa de selectedIndex -- esto NO dispara change/input
    // por sí solo, así que no hay riesgo de navegación ni de reejecutar
    // syncNativeSelection con un match real. El label decorativo de Athens
    // (assets/scripts.js, listener de change sobre .select-custom) se
    // restaura despachando un evento "change" sintético real DESPUÉS de
    // haber neutralizado el onchange de navegación -- se reutiliza ese
    // mecanismo nativo existente en vez de reimplementar la sincronización
    // del texto del label dentro de este archivo.
    function resetSelectToPlaceholder() {
      select.selectedIndex = 0;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Filtrado real por texto escrito en searchInput -- independiente del
    // <select>: no lo toca ni depende de su typeahead nativo. Oculta
    // (li.hidden) las filas cuyo texto no coincide, deja visibles las que
    // sí. Sin acentos/mayúsculas para que "sennheiser" encuentre
    // "Sennheiser" y nombres con tilde. Devuelve el primer <a> visible
    // para que Enter pueda navegar a él.
    function normalizeVendorText(text) {
      return (text || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim();
    }

    function filterVendorList(query) {
      var normalizedQuery = normalizeVendorText(query);
      var items = panel.querySelectorAll('.pm-vendor-dropdown-list li');
      var firstVisibleLink = null;

      items.forEach(function (item) {
        var link = item.querySelector('a');
        if (!link) return;
        var matches =
          normalizedQuery === '' ||
          normalizeVendorText(link.textContent).indexOf(normalizedQuery) !== -1;
        item.hidden = !matches;
        if (matches && !firstVisibleLink) firstVisibleLink = link;
      });

      clearHighlightedVendor();
      if (normalizedQuery !== '' && firstVisibleLink) {
        firstVisibleLink.classList.add('is-highlighted');
        scrollMatchIntoScroller(firstVisibleLink);
      }

      // "Sin coincidencias": solo cuando hay texto escrito y ningún
      // resultado visible -- con el panel recién abierto (query vacía)
      // nunca se muestra, aunque la lista esté momentáneamente vacía.
      emptyMessage.hidden = !(normalizedQuery !== '' && !firstVisibleLink);

      return firstVisibleLink;
    }

    // Listener de teclas de CONTROL únicamente (Escape, Enter, y las 3
    // combinaciones que abren el popup NATIVO del navegador/SO sobre el
    // propio <select>) -- nunca caracteres imprimibles: esos deben llegar
    // intactos al <select> para que el navegador ejecute su propio
    // typeahead nativo, que es el motor real de esta funcionalidad
    // (confirmado en la auditoría previa: Athens no implementa typeahead
    // en JavaScript). Registrado en document en fase de captura, solo
    // mientras el panel está abierto -- mismo mecanismo ya validado en la
    // corrección anterior, reutilizado sin crear una segunda
    // implementación de cierre.
    //
    // Auditoría "impedir popup nativo" (ver informe): el <select> real
    // sigue recibiendo foco real vía select.focus() en openPanel() --
    // imprescindible para el typeahead nativo, no se toca. Ese foco real
    // es justamente lo que permite que el navegador abra su propio popup
    // nativo (fuera del DOM/CSS de la página, imposible de tapar con
    // z-index/overflow) ante ciertas teclas estándar de cualquier
    // <select> HTML: Alt+ArrowDown, Alt+ArrowUp y F4. Ninguna de las tres
    // forma parte de un nombre de marca real ni del buffer de typeahead
    // nativo (que solo consume caracteres imprimibles vía keypress/input,
    // nunca estas combinaciones) -- bloquearlas con preventDefault() es
    // seguro y no interfiere con select.selectedIndex, syncNativeSelection,
    // scrollMatchIntoScroller ni .is-highlighted, que dependen únicamente
    // de los eventos 'input'/'change' que el navegador sigue disparando
    // con normalidad para el resto de las teclas.
    //
    // Space queda deliberadamente FUERA de este fix (ver informe,
    // sección "Space"): su efecto sobre el buffer de typeahead nativo de
    // un <select> varía entre navegadores y no puede verificarse con
    // certeza en este entorno sin acceso a un navegador real -- bloquear
    // preventDefault() a ciegas arriesga romper el typeahead de marcas
    // con espacio en el nombre (AUDIO TECHNICA, BLUE MICROPHONES, TC
    // ELECTRONICS, SKP PRO AUDIO, DB TECHNOLOGIES...), justo lo que este
    // fix debe proteger. Se documenta como limitación residual en vez de
    // arriesgar una regresión funcional.
    function handleControlKeydown(event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        closePanel();
        trigger.focus();
        return;
      }

      if (event.key === 'Enter') {
        if (document.activeElement !== select) return;
        var selectedOption = select.options[select.selectedIndex];
        if (!selectedOption || selectedOption.value === '') return;
        event.preventDefault();
        window.location.assign(selectedOption.value);
        return;
      }

      // Alt+ArrowDown / Alt+ArrowUp / F4: únicas teclas de apertura del
      // popup nativo que se pueden distinguir con certeza de un carácter
      // de typeahead legítimo. Acotado a cuando el foco real está en el
      // <select> (mismo guard que usa la rama de Enter) -- estas teclas
      // solo importan mientras es él quien tiene el foco.
      if (document.activeElement === select) {
        var opensNativePopup =
          event.key === 'F4' ||
          ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && event.altKey);

        if (opensNativePopup) {
          event.preventDefault();
        }
      }
    }

    function attachControlKeydownListener() {
      document.addEventListener('keydown', handleControlKeydown, true);
    }

    function detachControlKeydownListener() {
      document.removeEventListener('keydown', handleControlKeydown, true);
    }

    function closePanel() {
      if (panel.hidden) return;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      detachControlKeydownListener();
      // Sin residuo de una búsqueda anterior al reabrir -- limpia tanto
      // el highlight/filtro de searchInput (filterVendorList('') ya
      // limpia el highlight internamente) como el <select> nativo.
      searchInput.value = '';
      filterVendorList('');
      resetSelectToPlaceholder();
    }

    function openPanel() {
      // Reinicio ANTES de mostrar el panel: mismo motivo que antes para
      // el <select> (evitar arrastrar un filtro/selección de una sesión
      // previa), ahora aplicado también a searchInput.
      resetSelectToPlaceholder();
      searchInput.value = '';
      filterVendorList('');
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      attachControlKeydownListener();
      // El foco real queda en searchInput (input de texto real), NO en
      // el <select>: un <select> nunca abre el teclado táctil en mobile,
      // aunque reciba foco programático -- esa es justamente la causa
      // raíz de la falla "no se activa el teclado" que este fix
      // resuelve. searchInput.focus() ocurre de forma SÍNCRONA dentro
      // del gesto de click del usuario (ver listener del trigger más
      // abajo) -- imprescindible en iOS, que ignora focus() disparado
      // fuera de un gesto directo. El <select> y su typeahead nativo
      // quedan intactos como mecanismo (documentado arriba), simplemente
      // ya no son el punto de entrada por defecto: searchInput.input
      // filtra la lista en tiempo real para todos los dispositivos.
      searchInput.focus({ preventScroll: true });
    }

    searchInput.addEventListener('input', () => {
      filterVendorList(searchInput.value);
    });

    // Enter navega al primer resultado visible -- equivalente táctil/
    // mobile de la rama Enter que ya existe en handleControlKeydown para
    // el <select> (esa rama sigue intacta y solo actúa cuando el foco
    // real está en el <select>, lo que ya no ocurre por defecto).
    searchInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var firstVisibleLink = panel.querySelector('.pm-vendor-dropdown-list li:not([hidden]) a');
      if (firstVisibleLink) {
        window.location.assign(firstVisibleLink.getAttribute('href'));
      }
    });

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    // Permanentes (no ligados a open/close): syncNativeSelection ya se
    // protege con isOpen() al inicio, así que no hace falta añadir y
    // retirar este par en cada apertura. "input" cubre el cambio
    // inmediato en los navegadores que lo emiten durante el typeahead
    // nativo de un <select>; "change" cubre el resto. syncNativeSelection
    // es idempotente, así que escuchar ambos nunca duplica trabajo con
    // efectos visibles.
    select.addEventListener('input', syncNativeSelection);
    select.addEventListener('change', syncNativeSelection);

    // root.contains(...) sustituye a la comprobación anterior de
    // panel.contains(...) || trigger.contains(...): select y su <label>
    // decorativo son HERMANOS de panel y trigger dentro de root, nunca
    // descendientes de panel ni de trigger (ver snippets/header-search.
    // liquid: los cuatro son hijos directos del mismo div). Con la
    // arquitectura anterior (el select nunca recibía foco real) esa
    // distinción no importaba; ahora que openPanel() llama
    // select.focus(), un focusin con target=select debe tratarse como
    // foco INTERNO del componente. La comprobación anterior lo habría
    // interpretado como foco externo y cerrado el panel en el mismo
    // instante en que se abre -- root.contains cubre select, label,
    // trigger y panel por igual, sin ese falso positivo.
    document.addEventListener('click', (event) => {
      if (!panel.hidden && !root.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener('focusin', (event) => {
      if (!panel.hidden && !root.contains(event.target)) {
        closePanel();
      }
    });
  });
})();
